import 'normalize.css';
import React from 'react';
import ReactDOM from 'react-dom';
import ReactModal from 'react-modal';

import Root from 'components/Root';

import store from 'config/store';
import history from 'config/history';
import Routes from 'config/routes';

import './index.css';

ReactModal.setAppElement('#root');

ReactDOM.render(
  <Root store={store} history={history} Routes={Routes} />,
  document.getElementById('root')
);
